<template>
    <div class="x-postcontent x-postcontent-0 clearfix">
        <div class="x-content-layout layout-item-0">
            <div class="x-content-layout-row">
                <div
                    class="x-layout-cell layout-item-1"
                    style="width: 50%"
                    >
                    <table class="x-article" style="width: 100%; ">
                        <tbody>
                            <tr>
                                <td style="width: 100%; ">
                                    <h1 class="header">Ixat</h1>
                                    <div class="col-group">
                                        <div class="col-6 col-md-12">
                                            <IxatImage name="Haar er af" src="haar_er_af" />
                                        </div>
                                        <div class="col-6 col-md-12">
                                            <IxatImage name="Cbr" src="cbr" />
                                        </div>
                                        <div class="col-6 col-md-12">
                                            <IxatImage name="Gevonden voorwerpen" src="gevonden_voorwerpen" />
                                        </div>
                                        <div class="col-6 col-md-12">
                                            <IxatImage name="Naakte man" src="naakte_man" />
                                        </div>
                                        <div class="col-6 col-md-12">
                                            <IxatImage name="Uberweg" src="uberweg" />
                                        </div>
                                        <div class="col-6 col-md-12">
                                            <IxatImage name="Weg puzzel" src="weg_puzzel" />
                                        </div>
                                        <div class="col-6 col-md-12" style="padding-bottom: 15px">
                                            <div class="ratio-box-60">
                                                <div class="ratio-content">
                                                    <iframe 
                                                        class="embeded-video ixat-video"
                                                        src="https://www.youtube.com/embed/yjSkX_vbGqc" 
                                                        frameborder="0" 
                                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                                        allowfullscreen />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 col-md-12">
                                            <div class="ratio-box-60">
                                                <div class="ratio-content ">
                                                    <iframe 
                                                        class="embeded-video ixat-video"
                                                        src="https://www.youtube.com/embed/PRpdXz_0aH8"
                                                        frameborder="0" 
                                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                                        allowfullscreen />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.ixat-video{
    margin-top: 20px;
    padding-bottom: 20px;
}
</style>


<script>
import IxatImage from '@/components/IxatImage';
export default {
    name: 'contact',
    components: {
        'IxatImage': IxatImage,
    }
}
</script>
